export default "__VITE_ASSET__amG$1441__"